interface AboutData {
  about_title: string;
  about_subtitle: string;
  about_content: string;
  about_image: string;
}

interface AboutEditorProps {
  data: AboutData;
  onChange: (data: AboutData) => void;
}

export default function AboutEditor({ data, onChange }: AboutEditorProps) {
  const handleChange = (field: keyof AboutData, value: string) => {
    onChange({
      ...data,
      [field]: value,
    });
  };

  return (
    <div className="space-y-6">
      <div className="border-b pb-4">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <i className="ri-information-line text-blue-600"></i>
          Sección Quiénes Somos
        </h2>
        <p className="text-gray-600 mt-1">Información sobre tu empresa</p>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Título Principal
          </label>
          <input
            type="text"
            value={data.about_title}
            onChange={(e) => handleChange('about_title', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ej: Acerca de Axloweb"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Subtítulo (opcional)
          </label>
          <input
            type="text"
            value={data.about_subtitle}
            onChange={(e) => handleChange('about_subtitle', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ej: Tu Socio en Marketing Digital"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Contenido Completo
          </label>
          <textarea
            value={data.about_content}
            onChange={(e) => handleChange('about_content', e.target.value)}
            rows={12}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
            placeholder="Escribe aquí toda la información sobre tu empresa..."
          />
          <p className="text-sm text-gray-500 mt-2">
            Puedes usar saltos de línea para separar párrafos
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL de Imagen (opcional)
          </label>
          <input
            type="text"
            value={data.about_image}
            onChange={(e) => handleChange('about_image', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="https://ejemplo.com/imagen.jpg"
          />
          {data.about_image && (
            <div className="mt-4">
              <p className="text-sm font-medium text-gray-700 mb-2">Vista previa:</p>
              <img
                src={data.about_image}
                alt="Preview"
                className="w-full max-w-md h-64 object-cover rounded-lg border border-gray-200"
              />
            </div>
          )}
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
          <i className="ri-information-line"></i>
          Vista Previa del Contenido
        </h3>
        <div className="bg-white rounded-lg p-6 border border-blue-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">{data.about_title}</h2>
          {data.about_subtitle && (
            <p className="text-lg text-blue-600 mb-4">{data.about_subtitle}</p>
          )}
          <div className="text-gray-600 whitespace-pre-line">{data.about_content}</div>
        </div>
      </div>
    </div>
  );
}
